/**
 * Nome pubblico di un titolo, accanto al suo nome di catalogo (F-087).
 *
 * Un componente e non tre righe copiate in tre pagine, perché porta **due
 * regole** e non solo del markup:
 *
 * 1. **Assente non si disegna.** Senza questo, una riga vuota comparirebbe
 *    sotto ogni titolo per cui il provider non ha un nome — un difetto grafico
 *    senza causa apparente.
 * 2. **Uguale al nome di catalogo non si disegna.** Per un titolo importato
 *    bene, `name` e nome commerciale coincidono: mostrarli entrambi
 *    raddoppierebbe la stessa parola su metà dei titoli, e la seconda etichetta
 *    smetterebbe di significare qualcosa. Il confronto ignora maiuscole e spazi,
 *    perché «APPLE INC» e «Apple Inc.» sono lo stesso nome scritto da due
 *    registri diversi — ed è esattamente il caso in cui non serve ripeterlo.
 *
 * Serve a **riconoscere**, non a identificare: «CONSOLIDATED WATER CO-ORD SH»
 * dice quale riga è, «Consolidated Water Co. Ltd.» dice che società è.
 */

/** Confronto lasco: due registri scrivono lo stesso nome in modi diversi. */
function sameName(a: string, b: string): boolean {
  const normalize = (value: string) =>
    value
      .toLowerCase()
      .replace(/[.,'"()]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  return normalize(a) === normalize(b);
}

export function CommercialName({
  name,
  commercialName,
  size = 'normal',
}: {
  /** Il nome di catalogo, per non ripeterlo quando coincidono. */
  name: string;
  commercialName: string | null;
  size?: 'normal' | 'small';
}) {
  if (!commercialName?.trim()) return null;
  if (sameName(name, commercialName)) return null;

  return (
    <span className={`commercial-name commercial-name--${size}`} title="Nome commerciale del titolo">
      {commercialName}
    </span>
  );
}
